@if (userForm) {
<form [formGroup]="userForm">
  <aw-form-field>
    <aw-form-field-label [required]="required()">
      {{ title() }}
    </aw-form-field-label>

    <input
      AwInput
      aria-label="customer-info-field"
      [readOnly]="readOnly()"
      [placeholder]="placeholder()"
      type="text"
      formControlName="userInput"
    />

    @if ( required() && userForm.controls['userInput'].touched &&
    userForm.controls['userInput'].errors?.['userInput'] ) {
    <aw-form-message type="error">
      Please enter correct form values
    </aw-form-message>
    }
  </aw-form-field>
</form>
}
